<div *ngIf="visible$ | async" class="footer" fxLayout="row">
  <div
    *ngIf="(type$ | async) == 'initial'"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="24px"
    fxFlex="grow"
  >
    <div class="name" fxHide fxShow.gt-sm>
      {{ 'Footer.InitialMessage' | translate }}
    </div>

    <div class="dontShowAgain" fxHide fxShow.gt-sm>
      <mat-checkbox color="accent" [(ngModel)]="dontShowAgain">{{ 'Footer.DontShowAgain' | translate }}</mat-checkbox>
    </div>
  </div>
  <div *ngIf="(type$ | async) == 'report'" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px" fxFlex="grow">
    <div class="name" fxHide fxShow.gt-sm>
      {{ 'Footer.ReportMessage' | translate }}
    </div>
    <button (click)="download()" mat-icon-button type="button">
      <mat-icon>get_app</mat-icon>
    </button>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center">
    <button (click)="hide()" mat-icon-button type="button">
      <mat-icon class="close">close</mat-icon>
    </button>
  </div>
</div>
